import React, { useContext, useEffect, useMemo } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import objectPath from "object-path";
import { HamburgerMenu, KaporgIcon, UserIcon } from "../../../../app/assets/icons";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { Avatar, Button, Spin } from "antd";
import NotificationPopover from "../subheader/components/NotificationPopover";
import { NotificationContext } from "../subheader/notificationContext/NotificationContext";
// import AuthService from "../../../../app/base/services/authentication.service";
import { usePopoverStore } from "../subheader/store/usePopoverStore";
import { useAvatarStore } from "./store/useAvatarStore";
import { UserRolesEnum } from "../../../../app/pages/auth/userRoles.enum";
import AuthService from "../../../../app/base/services/authentication.service";
import PopoverLinks from "../subheader/components/PopoverLinks";
import { useTranslation } from "../../../../app/i18n/LanguageContext";

export function HeaderMobile() {
   const { t } = useTranslation();
   const location = useLocation();
   const navigate = useNavigate();
   const uiService = useHtmlClassService();
   const user = AuthService?.getUser();

   const isHumanitarian = AuthService.isAuthorized([UserRolesEnum.Consultant]);
   const isSuperAdmin = AuthService.isAuthorized([UserRolesEnum.SuperAdmin]);
   const isNgo = AuthService.isAuthorized([UserRolesEnum.NationalOrganization]);
   const isApprover = AuthService.isAuthorized([UserRolesEnum.Approver]);
   const logoHomeLink = isApprover
      ? "/approver/submissions"
      : isSuperAdmin
      ? "/admin/workspace"
      : "/workspace";

   const { handleClick, anchorEl, closePopover } = usePopoverStore();

   const { fullName, profileImage, imageLoading } = useAvatarStore();

   const {
      notifications,
      markNotificationAsRead,
      markAllNotificationsAsRead,
      loadingMarkAllRead,
      loadingMarkOneRead,
      setPopoverUnreadCount,
      setPopoverUnreadCountAll,
      setPopoverIncCount,
      toggleBell,
      handleCloseBell
   } = useContext(NotificationContext);

   const layoutProps = useMemo(() => {
      return {
         asideDisplay: objectPath.get(uiService.config, "aside.self.display"),
         headerMobileCssClasses: uiService.getClasses("header_mobile", true),
         headerMobileAttributes: uiService.getAttributes("header_mobile")
      };
   }, [uiService]);

   const shouldShowHamburger = (() => {
      const path = location.pathname;

      const normalized = path.replace(/\/+$/, "");

      return !(normalized === "/workspace" || normalized === "/admin/");
   })();

   const logout = () => {
      AuthService.logout();
      navigate("/auth/login");
   };

   useEffect(() => {
      closePopover();
   }, []);

   return (
      <>
         {/*begin::Header Mobile*/}
         <div
            id="kt_header_mobile"
            className={`header-mobile ${layoutProps.headerMobileCssClasses}`}
            // {...layoutProps.headerMobileAttributes}
            style={{ padding: "20px 16px" }}
         >
            <div className="d-flex justify-content-between" style={{ width: "100%" }}>
               <div
                  className="d-flex align-items-center"
                  style={{ gap: shouldShowHamburger ? "24px" : "0px" }}
               >
                  <div className="d-flex align-items-center">
                     {layoutProps.asideDisplay && shouldShowHamburger && (
                        <Button
                           icon={<img src={HamburgerMenu} alt={t("menu-toggle-icon-alt")} />}
                           className="p-0"
                           id="kt_aside_mobile_toggle"
                           style={{ border: "none", gap: 0 }}
                        >
                           <span />
                        </Button>
                     )}
                  </div>

                  <Link to={logoHomeLink}>
                     <img alt={t("logo-alt-text")} className="logo-default max-h-36px" src={KaporgIcon} />
                  </Link>
               </div>
               <div className="d-flex align-items-center" style={{ gap: "20px" }}>
                  <NotificationPopover
                     toggleBell={toggleBell}
                     user={user}
                     handleCloseBell={handleCloseBell}
                     notifications={notifications}
                     markNotificationAsRead={markNotificationAsRead}
                     markAllNotificationsAsRead={markAllNotificationsAsRead}
                     loadingMarkAllRead={loadingMarkAllRead}
                     loadingMarkOneRead={loadingMarkOneRead}
                     setPopoverUnreadCount={setPopoverUnreadCount}
                     setPopoverUnreadCountAll={setPopoverUnreadCountAll}
                     setPopoverIncCount={setPopoverIncCount}
                  />

                  <button
                     onClick={(e) => handleClick(e)}
                     style={{ cursor: "pointer", border: "none", background: "none" }}
                  >
                     {isHumanitarian ? (
                        imageLoading ? (
                           <Spin />
                        ) : (
                           <img
                              src={profileImage || UserIcon}
                              alt={t("profile-preview-alt-text")}
                              className="avatar"
                              style={{ borderRadius: "50%", width: "50px", height: "50px" }}
                           />
                        )
                     ) : (
                        <Avatar className="avatar" style={{ width: "50px", height: "50px" }}>
                           {fullName?.charAt(0).toUpperCase()}
                        </Avatar>
                     )}
                  </button>
               </div>
            </div>
         </div>
         <PopoverLinks
            anchorEl={anchorEl}
            handleClose={closePopover}
            logout={logout}
            isSuperAdmin={isSuperAdmin}
            isNgo={isNgo}
         />
      </>
   );
}
